import {create} from "zustand";
import {ConfEnv} from "../config/config";
import privateRequest from "../Infra/http/private.request";
import useCurrencyStore from "./useCurrency.store";

/**
 * Zustand store for El Inmejorable bingo functionality
 * Following the same pattern as useHorsesStore
 */
export const useBingoStore = create(set => ({
  // State
  gameUrl: null,
  loading: false,
  error: null,
  screenMode: window.innerWidth <= 768 ? "fullscreen" : "centered", // Mobile: fullscreen, Desktop: centered

  // Actions
  /**
   * Start El Inmejorable bingo game and get the iframe URL
   * @param {string} currency - The currency to use (default: VES)
   */
  startBingoGame: async (currency = "VES") => {
    set({loading: true, error: null});

    try {
      // Get the selected currency from the currency store or use provided currency
      const selectedCurrency = useCurrencyStore.getState().selectedCurrency;
      const currencyParam = currency || (selectedCurrency ? selectedCurrency.id : "VES");

      const response = await privateRequest.post(`${ConfEnv.BASE_URL}/bingo/start-game?currency=${currencyParam}`, {
        currency: currencyParam,
      });
      const payload = response?.data?.data || {};
      const gameUrl = payload.game_url || payload.gameUrl || payload.url || null;
      set({
        gameUrl,
        loading: false,
        error: null,
      });
    } catch (e) {
      set({
        loading: false,
        error: {message: e.message, code: e.status},
        gameUrl: null,
      });
    }
  },

  /**
   * Clear game URL and reset state
   */
  unload: () => {
    set({
      gameUrl: null,
      error: null,
    });
  },

  /**
   * Set screen mode (fullscreen or centered)
   * @param {string} mode - "fullscreen" or "centered"
   */
  setScreenMode: mode => {
    set({screenMode: mode});
  },

  /**
   * Reset screen mode to default based on screen size
   */
  resetScreenModeToDefault: () => {
    const defaultMode = window.innerWidth <= 768 ? "fullscreen" : "centered";
    set({screenMode: defaultMode});
  },

  /**
   * Clear any errors
   */
  clearError: () => {
    set({error: null});
  },
}));
